<template>
  <van-nav-bar
    :title="title"
    @click-right="onClickLeft"
  >
    <!-- 自定义右侧内容 -->
    <template #right>
      <van-icon
        name="scan"
        size="25"
        color="#555"
      />
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'TitleBar',
  props: {
    title: {
      type: String,
      required: true,
    }
  },
  methods: {
    onClickLeft () {
      this.$router.push({
        path: '/readyCode'
      });
    },
  },
};
</script>

<style scoped>
/* 样式 */
</style>
